module.exports = __webpack_public_path__ + "img/express-trailers-logo.a1487c22.png";